"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleEmail = void 0;
const core_1 = require("@veeam/core");
const constants_1 = require("../../../constants");
const utils_1 = require("../../utils");
const multipleEmail = (errorTexts) => {
    return (value, values) => {
        if (!value || typeof value !== 'string') {
            return '';
        }
        const emailValidator = core_1.regexp(new RegExp(constants_1.REG_EXP_LIST.email), utils_1.parseTextResource(errorTexts.invalidEmail, { email: value }));
        const emailList = value.split(';').map((item) => item.trim());
        if (emailList[emailList.length - 1].length === 0) {
            return errorTexts.emailNotFound;
        }
        if (emailList.length === 1) {
            return emailValidator(emailList[0], values, {});
        }
        return emailList.reduce((result, email) => {
            const currentMsg = emailValidator(email, values, {});
            if (currentMsg.length > 0) {
                return result.concat(utils_1.parseTextResource(errorTexts.invalidEmail, { email }), '\n');
            }
            return result;
        }, '');
    };
};
exports.multipleEmail = multipleEmail;
//# sourceMappingURL=multipleEmail.js.map